import React, { Component } from "react";
import { PageHeader, ListGroup, ListGroupItem, Breadcrumb } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Projects.css";
import { API, Storage } from "aws-amplify";
import EnhancedTable from "./EnhancedTable";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';


import loaderIcon from'../images/ftc_logo.gif';

import Slide from '@material-ui/core/Slide';

import moment from 'moment';

import JSZip from 'jszip';
import FileSaver from 'file-saver';




const rowHeaders = [
  { id: 'spivoltid', numeric: false, center: true, disablePadding: false, label: 'SPiVolt ID' },
  { id: 'created', numeric: false, center: true, disablePadding: false, label: 'Created' },
  { id: 'uploaded', numeric: false, center: true, disablePadding: false, label: 'Uploaded' },
  { id: 'battery', numeric: false, center: true, disablePadding: true, label: 'Battery (V)' },
  { id: 'temperature', numeric: false, center: true, disablePadding: true, label: 'Temperature (℃)' },
  { id: 'pressure', numeric: false, center: true, disablePadding: true, label: 'Pressure (kPa)' },
  { id: 'reftemperature', numeric: false, center: true, disablePadding: true, label: 'Ref Temperature (℃)' },
];
var chTot = 0;
for (let node = 1; node <= 1; node++) {
  for (let ch = 1; ch <= 64; ch++) {
    chTot += 1;
    var cnl = 'channel_' + chTot;
    var lbl = 'channel0' + ch + '\n(mV)';
    var nObj = { id: cnl, numeric: false, center: true, disablePadding: true, label: lbl };
    rowHeaders.push(nObj);
  }
}

function Transition(props) {
  return <Slide direction="right" {...props} />;
}

export default class SensorDataList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isDeleting: false,
      alertOpen: false,
      isLightBoxOpen: false,
      currentSPiVoltId: 'S0002',
      isRefreshing: false,
      currentSensorDataItem: null,
      sensorData: []
    };
  }
async componentDidMount() {
  //console.log(this.props);
  if (!this.props.isAuthenticated) {
    return;
  }
  this.initForSpivoltId(this.state.currentSPiVoltId);

  /*
  try {
    var sdata = await this.getSensorData(24, this.state.currentSPiVoltId); // 72 = 1 days worth
    let sensorData = [];

  for (var i = 0; i < sdata.length; ++i) {
    let sd = sdata[i];
    const {base64data, timeData, created} = sd;
    //var url = null;
    //if (p.logo) {
    //  url = await Storage.get(p.logo);
    //}
    var texts = timeData.split(",");
    var spiVoltId = "NOID";
    var timestamp = 0;
    var volts = 0;
    if (texts.length == 3) {
      spiVoltId = texts[0];
      timestamp = texts[1];
      volts = texts[2];
    } else {
      timestamp = texts[0];
      volts = texts[1];
    }


    //texts = timestamp.split("=");
    //timestamp = texts[1];
    //let momentObj = moment(timestamp, 'YY/M/D  H:m:sZ');
    //timestamp = momentObj.unix() * 1000;

    //timestamp = isNaN(timestamp) ? created - 321000 : timestamp;

    //texts = millisecs.split("=");
    //millisecs = texts[1];
    //var ms = Number(millisecs);


    let buff = new Buffer(base64data, 'base64');
    let text = buff.toString('ascii');

    let sArr = text.split("\n");



    for (var i2 = 0; i2 < sArr.length; ++i2) {
        let dArr = sArr[i2].split(",");
        console.log(dArr.length);
        var newRow = {};
        for (var i3 = 0; i3 < 68; ++i3) { //68 //36
            if (i3 < dArr.length) {
              let str = dArr[i3];
              if (i3 == 0) {
                 //let m = Number(str);
                 //let ctd = timestamp - (ms - m);
                 newRow.spivoltid = spiVoltId;
                 newRow.uploaded = (Number(timestamp) * 1000);
                 newRow.created = (Number(str) * 1000);
                 newRow.battery = volts;
              } else if (i3 == 1) {
                newRow["temperature"] = Number(str) / 100;
              } else if (i3 == 2) {
                newRow["pressure"] = Number(str) / 100000;
              } else if (i3 == 3) {
                newRow["reftemperature"] = Number(str) / 100;
              } else {
                //console.log(str);
                newRow["channel_" + (i3 - 3)] = Number(str) / 1000000;
              }
            } else {
              newRow["channel_" + (i3 - 3)] = "-";
            }
        }
        sensorData.push(newRow);
    }
  }




    const rows = await this.getStructuredSensorDataList(sensorData);



    this.setState({ sensorData, rows });
  } catch (e) {
    alert(e);
  }

  this.setState({ isLoading: false });


*/


}

async getStructuredSensorDataList(sensorData) {
  var rows = [];
  for (var i = 0; i < sensorData.length; ++i) {
    let sd = sensorData[i];
    const {spivoltid, battery, temperature, pressure, reftemperature, created, uploaded} = sd;
    let rowCols = [
      { id: 'spivoltid', numeric: false, center: false, disablePadding: false, value: spivoltid, type: 'text' },
      { id: 'created', numeric: false, center: false, disablePadding: false, value: (new Date(created - 3600000)).toLocaleString(), type: 'date' },
      { id: 'uploaded', numeric: false, center: false, disablePadding: false, value: (new Date(uploaded - 3600000)).toLocaleString(), type: 'date' },
      { id: 'battery', numeric: false, center: true, disablePadding: false, value: battery, type: 'text' },
      { id: 'temperature', numeric: false, center: true, disablePadding: false, value: temperature, type: 'text' },
      { id: 'pressure', numeric: false, center: true, disablePadding: false, value: pressure, type: 'text' },
      { id: 'reftemperature', numeric: false, center: true, disablePadding: false, value: reftemperature, type: 'text' }
    ];
    chTot = 0;
    for (let node = 1; node <= 1; node++) {
      for (let ch = 1; ch <= 64; ch++) { //32
        chTot += 1;
        rowCols.push({ id: 'channel_' + chTot, numeric: false, center: true, disablePadding: false, value: sd['channel_' + chTot], type: 'text' });
      }
    }

    /*
      ,
      { id: 'channel_1', numeric: false, center: true, disablePadding: false, value: channel_1, type: 'text' },
      { id: 'channel_2', numeric: false, center: true, disablePadding: false, value: channel_2, type: 'text' },
      { id: 'channel_3', numeric: false, center: true, disablePadding: false, value: channel_3, type: 'text' },
      { id: 'channel_4', numeric: false, center: true, disablePadding: false, value: channel_4, type: 'text' },
      { id: 'channel_5', numeric: false, center: true, disablePadding: false, value: channel_5, type: 'text' },
      { id: 'channel_6', numeric: false, center: true, disablePadding: false, value: channel_6, type: 'text' },
      { id: 'channel_7', numeric: false, center: true, disablePadding: false, value: channel_7, type: 'text' },
      { id: 'channel_8', numeric: false, center: true, disablePadding: false, value: channel_8, type: 'text' },
      { id: 'channel_9', numeric: false, center: true, disablePadding: false, value: channel_9, type: 'text' },
      { id: 'channel_10', numeric: false, center: true, disablePadding: false, value: channel_10, type: 'text' },
      { id: 'channel_11', numeric: false, center: true, disablePadding: false, value: channel_11, type: 'text' },
      { id: 'channel_12', numeric: false, center: true, disablePadding: false, value: channel_12, type: 'text' },
      { id: 'channel_13', numeric: false, center: true, disablePadding: false, value: channel_13, type: 'text' },
      { id: 'channel_14', numeric: false, center: true, disablePadding: false, value: channel_14, type: 'text' },
      { id: 'channel_15', numeric: false, center: true, disablePadding: false, value: channel_15, type: 'text' },
      { id: 'channel_16', numeric: false, center: true, disablePadding: false, value: channel_16, type: 'text' }

    ];

    */
    var newObj = {id: i + 1, spivoltid, battery, temperature, pressure, reftemperature, uploaded, created, key: created, cols: rowCols};
    for (let ch = 1; ch <= 64; ch++) { //64 //32
      newObj['channel_' + ch] = sd['channel_' + ch];
    }
    rows.push(newObj);
    //rows.push({id: i + 1, temperature, pressure, channel_16, channel_1, channel_2, channel_3, channel_4, channel_5, channel_6, channel_7, channel_8, channel_9, channel_10, channel_11, channel_12, channel_13, channel_14, channel_15, uploaded, created, key: created, cols: rowCols})
  }
  //console.log(rows);
  return rows
}
async initForSpivoltId(id) {
  try {
    var sdata = await this.getSensorData(24, id); // 72 = 1 days worth
    let sensorData = [];

  for (var i = 0; i < sdata.length; ++i) {
    let sd = sdata[i];
    const {base64data, timeData, created} = sd;
    //var url = null;
    //if (p.logo) {
    //  url = await Storage.get(p.logo);
    //}
    var texts = timeData.split(",");
    var spiVoltId = "NOID";
    var timestamp = 0;
    var volts = 0;
    if (texts.length == 3) {
      spiVoltId = texts[0];
      timestamp = texts[1];
      volts = texts[2];
    } else {
      timestamp = texts[0];
      volts = texts[1];
    }


    //texts = timestamp.split("=");
    //timestamp = texts[1];
    //let momentObj = moment(timestamp, 'YY/M/D  H:m:sZ');
    //timestamp = momentObj.unix() * 1000;

    //timestamp = isNaN(timestamp) ? created - 321000 : timestamp;

    //texts = millisecs.split("=");
    //millisecs = texts[1];
    //var ms = Number(millisecs);


    let buff = new Buffer(base64data, 'base64');
    let text = buff.toString('ascii');

    let sArr = text.split("\n");



    for (var i2 = 0; i2 < sArr.length; ++i2) {
        let dArr = sArr[i2].split(",");
        console.log(dArr.length);
        var newRow = {};
        for (var i3 = 0; i3 < 68; ++i3) { //68 //36
            if (i3 < dArr.length) {
              let str = dArr[i3];
              if (i3 == 0) {
                 //let m = Number(str);
                 //let ctd = timestamp - (ms - m);
                 newRow.spivoltid = spiVoltId;
                 newRow.uploaded = (Number(timestamp) * 1000);
                 newRow.created = (Number(str) * 1000);
                 newRow.battery = volts;
              } else if (i3 == 1) {
                newRow["temperature"] = Number(str) / 100;
              } else if (i3 == 2) {
                newRow["pressure"] = Number(str) / 100000;
              } else if (i3 == 3) {
                newRow["reftemperature"] = Number(str) / 100;
              } else {
                /*
                if ((i3 - 2) % 9 == 0) {
                  // skip, it is a gain value
                  //console.log("skip");
                } else {
                  var aa = Math.floor((i3 - 2) / 9);
                  //console.log(aa);
                  //console.log(i3 - 2 - aa);
                  newRow["channel_" + (i3 - 2 - aa)] = str;
                }
                */
                //console.log(str);
                newRow["channel_" + (i3 - 3)] = Number(str) / 1000000;
              }
            } else {
              newRow["channel_" + (i3 - 3)] = "-";
            }
        }
        sensorData.push(newRow);
    }
  }




    const rows = await this.getStructuredSensorDataList(sensorData);

/*
    var key = '';
    if (url) {
      let pos = url.indexOf('?AWSAccessKeyId');
      key = url.substring(pos);
    }
*/


    this.setState({ sensorData, rows });
  } catch (e) {
    alert(e);
  }

  this.setState({ isLoading: false, isRefreshing: false });
}

handleDownloadDataClick = async (event, selected) => {
  var zip = new JSZip();
  const csv = await this.getDataAsCSV(10000); // 2160 = 1 months worth
  zip.file("SpiVoltData_" + this.state.currentSPiVoltId + "_" + (new Date().toDateString()) + ".csv", csv);
  zip.generateAsync({type:"blob"})
  .then(function(content) {
      FileSaver.saveAs(content, "SpiVoltData.zip");
  });
}

async getDataAsCSV(limit) {

  var sdata = await this.getSensorData(limit, this.state.currentSPiVoltId);
  let sensorData = [];

  let csv = "SPiVolt ID,created,uploaded,created date,created time,uploaded date,uploaded time,battery(V),temperature(℃),pressure(kPa),ref_temperature(℃),ch01(mV),ch02(mV),ch03(mV),ch04(mV),ch05(mV),ch06(mV),ch07(mV),ch08(mV),ch09(mV),ch10(mV),ch11(mV),ch12(mV),ch13(mV),ch14(mV),ch15(mV),ch16(mV),ch17(mV),ch18(mV),ch19(mV),ch20(mV),ch21(mV),ch22(mV),ch23(mV),ch24(mV),ch25(mV),ch26(mV),ch27(mV),ch28(mV),ch29(mV),ch30(mV),ch31(mV),ch32(mV)";
  for (var i = 0; i < sdata.length; ++i) {
    let sd = sdata[i];
    const {base64data, timeData, created} = sd;
    var texts = timeData.split(",");
    //var timestamp = texts[0];
    //var volts = texts[1];

    var spiVoltId = "NOID";
    var timestamp = 0;
    var volts = 0;
    if (texts.length == 3) {
      spiVoltId = texts[0];
      timestamp = texts[1];
      volts = texts[2];
    } else {
      timestamp = texts[0];
      volts = texts[1];
    }

    let buff = new Buffer(base64data, 'base64');
    let text = buff.toString('ascii');
    let sArr = text.split("\n");
    for (var i2 = 0; i2 < sArr.length; ++i2) {
        let dArr = sArr[i2].split(",");
        //console.log(dArr.length);
        let rowStr = "\n";
        for (var i3 = 0; i3 < 68; ++i3) { //68 // 36
            if (i3 < dArr.length) {
              let str = dArr[i3];
              if (i3 == 0) {
                  rowStr += spiVoltId;
                  rowStr += "," + str;
                  rowStr += "," + timestamp;
                  rowStr += "," + (new Date(((Number(str)-3600) * 1000))).toLocaleString();
                  rowStr += "," + (new Date(((Number(timestamp)-3600) * 1000))).toLocaleString();
                  rowStr += "," + volts;
              } else if (i3 == 1) {
                rowStr += "," + Number(str) / 100;
              } else if (i3 == 2) {
                rowStr += "," + Number(str) / 100000;
              } else if (i3 == 3) {
                rowStr += "," + Number(str) / 100;
              } else {
                rowStr += "," + Number(str) / 1000000;
              }
            } else {
              rowStr += ",-";
            }
        }
        csv += rowStr;
    }
  }
  return csv;
}
/*

handleDownloadDataClick = async (event, selected) => {
  event.preventDefault();
  console.log(selected);
  this.selected = selected;
  this.setState({
    isDownloading: true,
  });
  this.currentDataIndex = 0;
  this.datazip = new JSZip();
  await this.loadData();
}

async loadData() {
  let idx = this.currentDataIndex;
  if ( idx < this.selected.length) {
    let orgId = this.props.org.pk;
    let projectId = this.state.projectId;
    const tripSk = this.selected[idx];
    let tripId = tripSk.substring(tripSk.lastIndexOf("|")+1);
    let path = `${orgId}/trips/${tripId}/json/${tripId}.trp`;
    console.log(path);
    await Storage.get(path)
    .then(result => this.extractJson(result))
    .catch(err => console.log('ERR: ' + err));
  } else {
    this.saveTripZip();
    const result = await this.updateTrips(this.selected);
    console.log(result);
    const trips = await this.getOrgProjectTrips();
    const rows = await this.getStructuredTripList(trips);
    this.setState({ isDownloading: false, trips, rows });
  }
}
extractJson(compressedJson) {
  let context = this;
  var xhr = new XMLHttpRequest();
  xhr.open("GET", compressedJson, true);
  xhr.onload = function()
  {
        let binaryString = xhr.response;
        let deflatedBinaryString = window.atob(binaryString);
        let jsonString = pako.inflate(deflatedBinaryString, { to: 'string' });
        let obj = JSON.parse(jsonString);
        let t = obj.trip;
        context.trip = t;
        context.json = jsonString;
        context.currentEventIndex = 0;
        context.populateFilePaths();

  }
  xhr.send();
}

populateFilePaths() {
  let idx = this.currentEventIndex;
  let orgId = this.props.org.pk;
  let projectId = this.state.projectId;
  const tripSk = this.selected[this.currentTripIndex];
  let tripId = tripSk.substring(tripSk.lastIndexOf("|")+1);
  if (idx < this.trip.events.length) {
    if (this.trip.events[idx].type === 'CAMERA') {
      let filename = this.trip.events[idx].values.filename;
      let path = `${orgId}/trips/${tripId}/photos/${filename}`;
      Storage.get(path)
        .then(result => this.addAuthenticatedFilePath(result))
        .catch(err => console.log('ERR: ' + err));
    } else if (this.trip.events[idx].type === 'AUDIO') {
      let filename = this.trip.events[idx].values.filename;
      let path = `${orgId}/trips/${tripId}/audio/${filename}`;
      Storage.get(path)
        .then(result => this.addAuthenticatedFilePath(result))
        .catch(err => console.log('ERR: ' + err));
    } else {
      this.currentEventIndex = idx + 1;
      this.populateFilePaths();
    }
  } else {
    console.log(tripSk);
    console.log(tripId);
    var folder = this.tripzip.folder(tripId);
    folder.file("trip.json", this.json);
    this.currentEventIndex = 0;
    this.getFilesAsBlobs();
  }
}




*/

















getSensorData(limit, id) {
  let spivoltid = '1';
  if (id != 'NOID') {
    spivoltid = id;
  }

  if (this.props.org) {
    return API.get("ftc", `/weatherpic/sensordata?limit=` + limit +`&id=` + spivoltid +``);
  } else {
    return API.get("ftc", `/weatherpic/sensordata?limit=` + limit +`&id=` + spivoltid +``);
  }
}
deleteProjects() {
  //console.log(this.state);
  const idList = this.state.selected;
  if (idList.length > 0) {
    const body = {ids: idList};
    if (this.props.org) {
      return API.del("ftc", `/organisations/${this.props.org.pk}/projects`, {body: body});
    } else {
      return API.del("ftc", `/organisations/user/projects`, {body: body});
    }
  }
}

handleCrumbClick = event => {
  event.preventDefault();
  this.props.history.push(event.currentTarget.getAttribute("href"));
}

getSensorDataIdFromSk(sk) {
  return sk.substr(4);
}

 renderSensorDataList(sensorData) {
  return [{}].concat(sensorData).map(
    (project, i) =>
      i !== 0
        ? <ListGroupItem
            key={project.sk}
            href={`/sensors/${this.getSensorDataIdFromSk(sensorData.sk)}`}
            onClick={this.handleSensorDataClick}
            header={sensorData.sk}
          >
            {"Created: " + new Date(project.created).toLocaleString()}
          </ListGroupItem>
        : <ListGroupItem
            key="new"
            href={"/projects/new"}
            onClick={this.handleProjectClick}
          >
            <h4>
              <b>{"\uFF0B"}</b> New Project
            </h4>
          </ListGroupItem>
  );
}



handleAlertClose = () => {
    this.setState({ alertOpen: false });
};
handleSensorDataClick = (event, sensorDataSk) => {
  console.log(event);
  /*
  event.preventDefault();
  const sensorItem = this.state.sensorData.find((item)=> item.sk === sensorDataSk );
  console.log(sensorItem);
  this.setState({
    currentsensorItem: sensorItem,
    isLightBoxOpen: true
  });
  */
}
handleTabClick = (event, selected) => {
  event.preventDefault();
  console.log(selected);
  if (this.state.currentSPiVoltId != selected) {
    this.setState({ currentSPiVoltId: selected, isRefreshing: true });
    this.initForSpivoltId(selected);
  }
}

handleLightBoxClose = () => {
    this.setState({ isLightBoxOpen: false, currentsensorItem: null });
  };


handleProjectEditClick = (event, selected) => {
  event.preventDefault();
  console.log(selected);
  this.props.history.push({
  pathname: '/projects/edit',
  state: { projectId: this.getProjectIdFromSk(selected[0]) }
  });
}
handleCreateProjectClick = event => {
  event.preventDefault();
  this.props.history.push("/projects/new");
}
handleDeleteProjectClick = async (event, selected) => {
  event.preventDefault();
  let count = selected.length;
  if (count > 0) {
    this.setState({
      alertOpen: true,
      selected: selected
    });
  }
}
 handleDeleteProjects = async (event) => {
   console.log(this.state);
   console.log('LEN0: ', this.state.rows.length);
  this.setState({ isDeleting: true, alertOpen: false });
  console.log('aaa');
  let isSuccess = false
  try {
    const result = await this.deleteProjects();
    console.log(result);
    isSuccess = true;
  } catch (e) {
    alert(e);
  }

  console.log('ddd');
  const projects = await this.getOrgProjects();
  const rows = await this.getStructuredProjectList(projects);
  console.log('LEN: ', rows.length);
  this.setState({ isDeleting: false, projects: projects, rows: rows });
}

/*
<MenuItem disabled={numSelected > 0} onClick={handleCreateItemClick}>Create new...</MenuItem>
<MenuItem disabled={numSelected != 1} onClick={event => handleEditItemClick(event, selected)}>Edit...</MenuItem>
<MenuItem disabled={numSelected == 0} onClick={event => actionsItemClickEvent(event, selected, handleDeleteItemClick)}>Delete</MenuItem>
*/


/*
async deleteProjects() {
  console.log('bbb');
  try {
    await this.deleteProjects();
  } catch (e) {
    alert(e);
  }
  console.log('ccc');

}
*/
renderLander() {
    return (
      <div className="lander">
        <h1>Sensor Data</h1>
        <p>Create your first project here</p>
          <LoaderButton
            bsStyle="primary"
            bsSize="large"
            isLoading={this.state.isLoading}
            onClick={this.handleCreateProjectClick}
            text="Create Project"
            loadingText="Create project"
          />


      </div>
    );
}


/*

      <div className="items">
        <PageHeader>{this.props.org ? this.props.org.orgName + ':' : 'My'} Projects</PageHeader>

*/
/*

handleEditItemClick={this.handleProjectEditClick}
handleCreateItemClick={this.handleCreateProjectClick}
handleDeleteItemClick={this.handleDeleteProjectClick}



*/

renderSensorData() {
  const menuItems = [
    { id: 0, label: 'Download', lt: Number.MAX_VALUE, gt: 0, isOrOperator: false, action: this.handleDownloadDataClick, divider: true, type: 'download' },
    //{ id: 0, label: 'Create new...', lt: Number.MAX_VALUE, gt: 0, isOrOperator: false, action: this.handleCreateProjectClick, divider: false, type: 'create'},
    //{ id: 1, label: 'Edit...', lt: 1, gt: 1, isOrOperator: true, action: this.handleProjectEditClick, divider: false, type: 'edit' },
    //{ id: 2, label: 'Delete', lt: 1, gt: -1, isOrOperator: false, action: this.handleDeleteProjectClick, divider: false, type: 'delete' }
  ];
  //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
  //console.log(this.state.rows);
  //console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
    return (
        <div>
          {!this.state.isLoading && <EnhancedTable
                                        logosKey={this.state.key}
                                        title='Sensor Data'
                                        tabs={[{id:'NOID',title:'Radyr'},{id:'S0002',title:'Llampha'}]}
                                        selectedTab={this.state.currentSPiVoltId}
                                        isRefreshing={this.state.isRefreshing}
                                        tooltip=''
                                        items={this.state.rows}
                                        menuItems={menuItems}
                                        handleItemClick={this.handleSensorDataClick}
                                        handleTabClick={this.handleTabClick}
                                        rowHeaders={rowHeaders}
                                        orderBy='created'
                                        order='desc'
                                        />}
          </div>
    );
  }

  renderLoader() {
    const label = this.state.isDeleting ? 'deleting...' : 'loading...';
    return(

      <div id="splash" style={{paddingTop: 250, zIndex:999}}>

    		<center id="splash">
    			<img src={loaderIcon}/>
          <Typography style={{padding: '4px'}} variant="caption">{label}</Typography>
    		</center>
    	</div>



    )
  }

  render() {
    return (
    <div>
        <Breadcrumb className="breadcrumb" style={{top: 58, left: 66, right: 0, position: 'absolute', zIndex:999, backgroundColor: '#FFF'}}>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Sensors</Breadcrumb.Item>
        </Breadcrumb>

      <div className="Projects" style={{position: 'absolute', left:80, right:80,top: 80, paddingBottom:50}}>
        {this.state.isLoading || this.state.isDeleting ? this.renderLoader() : this.state.sensorData.length > 0 ? this.renderSensorData() : this.renderLander()}
      </div>

      <Dialog
        open={this.state.isLightBoxOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={this.handleLightBoxClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {'Conditions - ' + (this.state.currentSensorItem && new Date(this.state.currentSensorItem.updated).toLocaleString())}
        </DialogTitle>
        <DialogContent>

        <DialogContentText id="alert-dialog-slide-description">
        {this.state.currentSensorItem && ("Temperature: " +  this.state.currentSensorItem.temperature + "℃")}
        </DialogContentText>
        <DialogContentText id="alert-dialog-slide-description">
        {this.state.currentSensorItem && ("Pressure: " +  this.state.currentSensorItem.pressure + "kPa")}
        </DialogContentText>



        {this.state.currentSensorItem && <img src={this.state.currentSensorItem.base64data} style={{maxWidth: 500, maxHeight:500}}/>}




          </DialogContent>
        <DialogActions>
          <Button onClick={this.handleLightBoxClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
          open={this.state.alertOpen}
          onClose={this.handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Projects"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you wish to delete the selected projects? <br/><br/>This cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleAlertClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={this.handleDeleteProjects} color="primary" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/SensorDataList.js